import { ActionsStore } from '../components/Actions/stores/ActionsStore.js';
/* [Component: storesImport] */
import { TStoreContext } from '../models/app/TStoreContext.js';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function setupStoreContext(storeContext: TStoreContext) {
	storeContext.set('actionsStore', new ActionsStore(storeContext, storeContext.manifest));
	/* [Component: stores] */
}
